/**
 * Confirm Service
 *
 * Displays a confirmation modal and returns a Promise<boolean>.
 * Replaces native window.confirm() with a styled modal.
 *
 * Utilise le système .nm-modal (HTML5 <dialog>) — backdrop natif + focus
 * trap géré par le navigateur. Aucune dépendance CSS supplémentaire.
 */

export default function confirm(message, { title = "Confirmation", confirmLabel = "Supprimer", cancelLabel = "Annuler" } = {}) {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog");
    dialog.className = "nm-modal";

    dialog.innerHTML = `
      <header class="nm-modal__head">
        <h2>${escapeHtml(title)}</h2>
      </header>
      <div class="nm-modal__body">
        <p>${escapeHtml(message)}</p>
      </div>
      <footer class="nm-modal__foot">
        <button type="button" class="nm-btn nm-btn--ghost" value="cancel">${escapeHtml(cancelLabel)}</button>
        <button type="button" class="nm-btn nm-btn--solid" value="confirm">${escapeHtml(confirmLabel)}</button>
      </footer>
    `;

    document.body.appendChild(dialog);

    const cancelBtn = dialog.querySelector('[value="cancel"]');
    const confirmBtn = dialog.querySelector('[value="confirm"]');

    cancelBtn.addEventListener("click", () => dialog.close("cancel"));
    confirmBtn.addEventListener("click", () => dialog.close("confirm"));

    dialog.addEventListener("close", () => {
      const result = dialog.returnValue === "confirm";
      dialog.remove();
      resolve(result);
    });

    // Clic sur le backdrop (zone hors <dialog>) → fermeture comme « Annuler ».
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) {
        dialog.close("cancel");
      }
    });

    dialog.showModal();
    cancelBtn.focus();
  });
}

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
